import { render } from "./SmallTicket.vue?vue&type=template&id=4ef96819&scoped=true"
import script from "./SmallTicket.vue?vue&type=script&lang=js"
export * from "./SmallTicket.vue?vue&type=script&lang=js"

import "./SmallTicket.vue?vue&type=style&index=0&id=4ef96819&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef96819"]])

export default __exports__